import { useTranslation } from 'react-i18next'
import clsx from 'clsx'
import React from 'react'
import PropTypes from 'prop-types'
import styles from 'components/Modal/modal.module.scss'

export const CloseLine = ({ className, ...rest }) => {
  const { t } = useTranslation(['common'])

  return (
    <button
      title={t('close_button')}
      className={clsx(className, styles['close-line'])}
      {...rest}
    />
  )
}
CloseLine.propTypes = {
  color: PropTypes.string,
  colorHover: PropTypes.string,
  colorActive: PropTypes.string,
  bgColor: PropTypes.string,
  bgColorHover: PropTypes.string,
  bgColorActive: PropTypes.string,
  className: PropTypes.string,
}
